
import Vue from "vue";
export default Vue.extend({
	props: {
		keyboardNavigation: Boolean,
		disabled: Boolean
	},
	methods: {
		clicked() {
			this.$emit("click");
		},
		focus() {
			(this.$el as HTMLElement).focus();
		},
		onKeyUp(event:KeyboardEvent) {
			let el = this.$el;
			if (event.key == "ArrowDown") {
				while(el.nextElementSibling) {
					el = el.nextElementSibling;
					if (!el.classList.contains("disabled") && el.classList.contains("w-select-option")) {
						(el as any).focus();
						break;
					}
				}
			} else if (event.key == "ArrowUp") {
				while(el.previousElementSibling){
					el = el.previousElementSibling;
					if (!el.classList.contains("disabled") && el.classList.contains("w-select-option")){
						(el as any).focus();
						break;
					}
				}
			} else if (event.key == "Escape") {
				this.$emit("close");
			}
			this.$emit("keyboard-navigation");
			event.preventDefault();
		}
	}
});
